// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"70271b12","106":"643675bf","147":"91c72304","453":"dcefe9c8","615":"0e22009a","620":"27c235a8","742":"ce51d8a5","807":"b638c4c3","896":"2faf0500","900":"ab669264","976":"07ee8afe","994":"3e1c229f"}[chunkId] + ".chunk.js";
};